export default __webpack_public_path__ + "static/media/bg1.37f9618a.jpg";